import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useSidePanelToggle from '#/user/hooks/useSidePanelToggle';
import * as Styled from './styled';

function DetailViewLayout({ top, middle, bottom, hasInverseBackground }) {
  const alertBannerIsVisible = useSelector(s => s.user.alertBannerIsVisible);
  const hideMapOnMobile = useSelector(s => s.map.hideMapOnMobile);
  const { readyToRemoveFromDom } = useSidePanelToggle();

  return (
    <Styled.DetailViewWrapper alertBannerIsVisible={alertBannerIsVisible}>
      {top && <Styled.DetailViewTop>{top}</Styled.DetailViewTop>}
      {!readyToRemoveFromDom && (
        <>
          {middle && (
            <Styled.DetailViewMiddle>{middle}</Styled.DetailViewMiddle>
          )}
          {bottom && (
            <Styled.DetailViewBottom
              hasInverseBackground={hasInverseBackground}
              hideMapOnMobile={hideMapOnMobile}
            >
              {bottom}
            </Styled.DetailViewBottom>
          )}
        </>
      )}
    </Styled.DetailViewWrapper>
  );
}

DetailViewLayout.propTypes = {
  /**
   * Determines if the inverse color palette should be used for the background
   * of the bottom panel
   */
  hasInverseBackground: PropTypes.bool,
  /** Elements to appear above the layout */
  top: PropTypes.node,
  /** Elements that will automatically resize the middle row of the layout */
  middle: PropTypes.node,
  /** Elements that will take up the remaining height on desktop */
  bottom: PropTypes.node,
};

DetailViewLayout.defaultProps = {
  hasInverseBackground: false,
  top: null,
  middle: null,
  bottom: null,
};

export default DetailViewLayout;
